import { toast } from "react-toastify";
import errorMessage from "../asset/data/error";
import momentJalaali from 'moment-jalaali';

import fa from 'moment/locale/fa';

export function errorHandler(err) {
  if (err.response && err.response.data) {
    toast.error(errorMessage[err.response.status]);
  }
}

export function getFilterName(pathname) {
  const path = (pathname && pathname.split('/')) || window.location.pathname.split('/');
  const result = [];
  path.forEach(item => {
    if (!!item) result.push(item);
  });
  return  result;
}

export function isObject(data) {
  return data !== null && typeof data === 'object' && !Array.isArray(data);
}

export function isElement(data) {
  return isObject(data) && data.nodeType === 1;
}

export function isNumber(data) {
  return typeof data === 'number';
}

export function isBoolean(data) {
  return typeof data === 'boolean';
}

export function isEmpty(data) {
  return !(Array.isArray(data) ?
    data.length : (
      isObject(data) ?
        isElement(data) || Object.keys(data).length : (
        !(isNumber(data) || isBoolean(data)) ? data : true
        )
    )
  );
}

export function objectsToFlatString(target, key) {
  if (!Array.isArray(target) ) return "";
  const flatString = target.reduce((accumulator, currentValue) => accumulator + `${isEmpty(currentValue[key]) ? "" : currentValue[key] + ','}`, '');
  return flatString.replace(/,*$/, '');
}

export function objectToQueryParameter(object) {
  if (!isObject(object)) return "";
  const query = Object.keys(object).reduce((accumulator, currentKey) => {
    const parameter = isEmpty(object[currentKey]) ? '' : `${currentKey}=${Array.isArray(object[currentKey]) ? objectsToFlatString(object[currentKey], 'id') : object[currentKey]}&`;
    return accumulator + parameter;
  }, '');
  return query.replace(/&*$/, '');
}

export function parseQuery(query) {
  const queryData = query.replace("?", "").split("&");
  if (!queryData.length || !queryData[0]) return {};

  return queryData.reduce((acc, current) => {
    const singleQuery = current.split("=");
    const queryParameter = singleQuery.length === 2 ? {[singleQuery[0]]: singleQuery[1]} : {};
    return { ...acc, ...queryParameter};
  }, {});
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function timeAgo(timestamp, milisecond = true) {
  return momentJalaali(timestamp * (milisecond ? 1 : 1000)).fromNow();
}

export function invalidWarning(message = null) {
  toast.warn(message ? message : "اطلاعات را به درستی وارد کنید");
}

export function successToast(message = null) {
  toast.success(message ? message : "عملیات با موفقیت انجام شد");
}

export function errorToast(message = null) {
  toast.error(message ? message : "خطایی اتفاق افتاده است");
}
